import React,{ useState, useEffect } from 'react'
import "./CreateRole.css";
import { useDispatch } from "react-redux";
import { getRole, deleteRoleById, createRole ,getUserRole} from "./../../../../services/global_redux/globale_actions/Role.action"
import EditableTable from '../../../reUsableTemplates/EditableTable/EditableTable'
import CreateRoleTemplate from '../modalForm/createRoleTemplate';
import Slide from '@mui/material/Slide';
import total_role from "../../../../assets/global_assets/role_imgs/Group.png";
import gender from "../../../../assets/global_assets/role_imgs/gender.png";
import team from "../../../../assets/global_assets/role_imgs/team.png";
import role_table_title_icon from "../../../../assets/global_assets/role_imgs/role-table-title-icon.png";
import { ResponsivePie } from '@nivo/pie'
import base_role from "../../../../assets/global_assets/role_imgs/base_role.png"
import date_icon from "../../../../assets/global_assets/role_imgs/date.png"
import role_discription from "../../../../assets/global_assets/role_imgs/role_discription.png"
import role_name from "../../../../assets/global_assets/role_imgs/role_name.png"
import status from "../../../../assets/global_assets/role_imgs/status.png"

function CreateRole({ showSnackbar, setLoading }) {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [roleData, setRoleData] = useState([])
    const [openroledeletealert, setopenroledeletealert] = useState(false);
    const [deleteroleid, setroledeleteid] = useState(null);
    const use_company_code = JSON.parse(sessionStorage.getItem('user'));
    const [checkRoles , setCheckRoles] = useState([]);
    const currentUserBaseRole = use_company_code.base_role;
    const [createData, setCreateData] = useState(false);
    const [editData, setEditData] = useState(null);
    const [deleteData, setDeleteData] = useState(null);
    const [activeTab, setActiveTab] = useState(null);
    useEffect(() => {
      const savedTab = sessionStorage.getItem('activeTab') || "Registers";
      setActiveTab(savedTab);
    }, []);

    const header = [
      { key: "role_name", value: "Role Name", input: "none", icon: role_name, dataIcon: false, highlightName: false },
      { key: "base_role", value: "Base Role", input: "none", icon: base_role, dataIcon: false, highlightName: false },
      { key: "role_description", value: "Role Description", input: "text", icon: role_discription, dataIcon: false, highlightName: false },
      { key: "role_status", value: "Status", input: "text", icon: status , dataIcon: false, highlightName: true},
      // { key: "created_at", value: "Date", input: "text", icon: date_icon, dataIcon: false, highlightName: false  },
    ];

    const [actionChecked, setActionChecked] = useState("");
    
    const [formValues, setFormValues] = useState({
        role_name: '',
        base_role: '',
        role_description: '',
        permissions: [],
        role_status: '',
        user_dp: '',
        company_code :use_company_code.company_code
    });


  const modalhandleOpen = () => setOpen(true);
  const modalhandleClose = () => setOpen(false);
  const modalhandleChange = (e) => {
    const { name, value } = e.target;
    const trimmedValue = value.replace(/^\s+/, "");
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: trimmedValue,
    }));
  };
  const modalhandleSubmit = (e) => {
    e.preventDefault();
    create_Role(formValues);
    modalhandleClose();
  };
  const create_Role = async (formValues) => {
    setLoading(true);
    try {

      const response = await dispatch(createRole(formValues));
      setLoading(false);
      if (response.success === true) {
        showSnackbar(response.message, "success");
        setActionChecked("create");
      } else {
        showSnackbar(response.message, "warning");
      }
      handleFetchStates()
    } catch (err) {
      console.error("Failed to fetch states:", err);
    }
  };
  const handleFetchStates = async () => {
    try {
      const response = await dispatch(getRole());
        if(currentUserBaseRole === "SuperAdmin"){
            setRoleData(response.data.filter((data)=> data.base_role !== "SuperAdmin" && data.base_role !== "vendor"));
            setCheckRoles(response.data.filter((data)=> data.base_role !== "SuperAdmin" && data.base_role !== "vendor").map((data)=> data.role_name));
        }else if(currentUserBaseRole === "Admin"){
            setRoleData(response.data.filter((data)=> data.base_role !== "SuperAdmin" &&  data.base_role !== "Admin" && data.base_role !== "vendor" ));
            setCheckRoles(response.data.filter((data)=> data.base_role !== "SuperAdmin" &&  data.base_role !== "Admin" && data.base_role !== "vendor" ).map((data)=> data.role_name));
        }else if(currentUserBaseRole === "Processor"){
            setRoleData(response.data.filter((data)=> data.base_role === "Client"));
            setCheckRoles(response.data.filter((data)=> data.base_role === "Client").map((data)=> data.role_name));
        }else{
            setRoleData(null);
            setCheckRoles(null);
        }
    } catch (err) {
      console.error("Failed to fetch states:", err);
    }
  };
  useEffect(() => {
    handleFetchStates();
  }, [dispatch]);
  const handledeleteRoleClickOpenalert = (id) => {
    setopenroledeletealert(true);
    setroledeleteid(id)
  };
  const handleroledeleteClosealert = () => {
    setopenroledeletealert(false);
  };

  const deleteRole = async (id) => {
    setLoading(true);
    setopenroledeletealert(false);
    try {
      const response = await dispatch(deleteRoleById(id));
      if(response.success === true){
        showSnackbar(response.message, "success");
        setActionChecked("delete");
      }else{
        showSnackbar(response.message, "warning");
      }
      setLoading(false);
      handleFetchStates()
    } catch (err) {
      console.error("Failed to fetch states:", err);
    }
  };
  const pieData = [
    { id: "Male", label: "Male", value: 63, color: "rgb(107,217,231)" },
    { id: "Female", label: "Female", value: 27, color: "rgb(254,147,187)" }
  ]

    const rolesData = [
      { name: "Marketing", value: 46, color: "#0377fb",employees: 300 },
      { name: "Sales", value: 19, color: "#f68d06",employees: 300 },
      { name: "Finance", value: 20, color: "#0fb86b",employees: 300 },
      { name: "HR", value: 3, color: "#ff0000",employees: 300 },
      { name: "Developers", value: 10, color: "#6226ef",employees: 300 },
      { name: "Designers", value: 5, color: "#c056f2",employees: 300 },
    ];
  
    const total = rolesData.reduce((sum, role) => sum + role.value, 0);

    const getUserPermission = async () => {
      try {
          const response = await dispatch(getUserRole());
              const rawPermissions = response?.data?.permissions;
              const parsedPermissions = typeof rawPermissions === "string"
                  ? JSON.parse(rawPermissions)
                  : Array.isArray(rawPermissions) && typeof rawPermissions[0] === "string"
                  ? JSON.parse(rawPermissions[0])
                  : rawPermissions;
                  console.log(parsedPermissions.filter(item => item.section == "Configuration" && item.module === "User & Role Management"));
                  parsedPermissions.forEach((item) => {
                    const { section, module, sub_module } = item;
        
                    if (section === "Configuration" && module === "User & Role Management") {
                        const employeePermission = sub_module.find(sub => sub.name === 'Create Role');
                        if (employeePermission?.action) {
                            setCreateData(employeePermission.action.create);
                            setEditData(employeePermission.action.edit);
                            setDeleteData(employeePermission.action.delete);
                        }
                    }
                });
  
      } catch (err) {
        console.error("Failed to fetch states:", err);
      }
  
  };
  useEffect(() => {
    getUserPermission();
  }, [dispatch]);

const formatSerialNumber = (id) => {
  return `#ROL-${String(id).padStart(5, "0")}`;
};
  return (
    <div className="contaner-fluid m-0 p-0">
      <div className="role-main-container">
        <div className="role-main-lable">

          <h5 className={`${activeTab == "Registers" ? "text-dark" : "text-white"}`}>Add Roles</h5>
          <p className={`${activeTab == "Registers" ? "text-dark" : "text-white"}`}>Define a new role with specific access permissions.</p>
        </div>
      <div className="row p-0 m-0 role-main-box d-none">
        <div className="col-md-12">
          <div className="row">
          <div className="col role-box role-box-1 ">
            <div className="d-flex align-items-center mb-2">
              <div className=" role-box-icon-main ">
                <img src={total_role} alt="no img" className='role-box-icon' />
              </div>
              <h5 className="mb-0">Total Roles</h5>
            </div>

            {/* Total number */}
            <div className="role-content-box-1">
            <h2 className="">{rolesData.length}</h2>
            <p className="p-0 m-0">Total Number of Department</p>
            </div>

            {/* Progress bar line */}
            <div
              className="d-flex w-90 mb-3 dataline"
              style={{ height: "px", borderRadius: "4px", overflow: "hidden" }}
            >
              {rolesData.map((role, index) => (
                <div
                  key={index}
                  style={{ width: `${(role.value / total) * 100}%`, backgroundColor: role.color }}
                ></div>
              ))}
            </div>

            {/* Breakdown boxes */}
            <div className="row text-center g-2 role-breakdown-box-1 ">
              {rolesData.map((role, index) => (
                <div className="col-4" key={index}>
                  <div className=" rounded-3 p-2">
                    <h6 className="m-0 p-0">{role.value}%</h6>
                    <small className="d-flex justify-content-center">
                      <span className='valueFlag' style={{ backgroundColor: role.color }}></span> <span className='valueData'>{role.name}</span>
                    </small>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="col role-box role-box-2">
            {/* Header */}
            <div className="d-flex align-items-center mb-3">
              <div className=" role-box-icon-main">
                <img src={team} alt="no img"  className='role-box-icon' />
              </div>
              <h5 className="mb-0 fw-bold">Departments with Employees</h5>
            </div>

            {/* Department list */}
            <div className="department-list">
              {rolesData.map((role, i) => (
                <div key={i} className="d-flex justify-content-between align-items-center  department-card">
                  {/* Left side */}
                  <div>
                    <div className=" d-flex align-items-center">
                      <span className=" dashbar" style={{ backgroundColor: role.color }}></span>
                      <h3 className='p-0 m-0'>{role.name} Team</h3>
                    </div>
                    <p className="dataaa p-0 m-0">{role.employees} Employees</p>
                  </div>

                  {/* Right side (percentage) */}
                  <h6 className=" mb-0">{role.value}%</h6>
                </div>
              ))}
            </div>
          </div>


          <div className="col role-box role-box-3">
            {/* Chart */}
            
            <div className="d-flex align-items-center">
              <div className=" role-box-icon-main">
                <img src={gender} alt="no img"  className='role-box-icon' />
              </div>
              <h5 className="mb-0 fw-bold">Employee Gender Ratio</h5>
            </div>
            <div className="role-table-status-chart">
                            <ResponsivePie
                              data={pieData}
                              margin={{ top: 10, right:10, bottom: 10, left: 10 }}
                              innerRadius={0}
                              enableArcLabels={false}
                              enableArcLinkLabels={false}
                              colors={(d) => d.data.color}
                              isInteractive={true}
                              activeOuterRadiusOffset={6}
                              tooltip={() => null}
                              arcLabel={(d) => `${d.value}%`}
                              arcLabelsSkipAngle={0}
                              arcLabelsTextColor="#fff"
                              startAngle={-250} 
                              endAngle={360}
                            />


                          </div>

                        {/* Legend */}
                        <div className="role-table-status-legend">
                          {pieData.map((item, idx) => (
                            <>
                            <div key={idx} className="role-table-status-item">
                              
                              <div>
                                <h1 className="role-table-label p-0 m-0"><span
                                className="role-table-dot"
                                style={{ backgroundColor: item.color }}
                              ></span>{item.label}</h1>
                                <h1 className="role-table-value ">{item.value}%</h1>
                              </div>
                            </div>
                              {item.label === "Male" && <div className='role-table-dot-line'></div>}
                              </>
                          ))}
                        </div>
          </div>
          </div>
        </div>
      </div>
      </div>
      
      <div className=" role-main-container-table">
      <EditableTable      
        header={header}
        mainIcon={role_table_title_icon}
        title={'Role'}
        data={roleData}
        setEditableRow={false}
        setEditedValues={false}
        handledeleteClickOpenalert={deleteRole}
        editableRow={false}
        setLoading={setLoading}
        editedValues={false}
        getEditPermission = {false}
        getDeletePermission = {deleteData}
        date={false}
        submitdelete={false}
        handleSaveClick={false}
        showSnackbar={showSnackbar}
        actionChecked={actionChecked}
        setActionChecked={setActionChecked}
        createOrfilterComp={
          <>
            {createData &&
            <>
              <button onClick={modalhandleOpen}>Create Roles</button>
                <CreateRoleTemplate
                  open={open}
                  handleClose={modalhandleClose}
                  formValues={formValues}
                  handleChange={modalhandleChange}
                  handleSubmit={modalhandleSubmit}
                  userRole = {currentUserBaseRole}
                />
            </>
            }      
          </>                  
        }
      />
      </div>
    </div>
  )
}

export default CreateRole
